import { isTestEnv } from '@app/constants';

export const recordsPerPage = isTestEnv ? 3 : 25;
export const maxContributorsToDisplay = 3;
